import styled from 'styled-components';
import { Link } from 'react-router-dom';


const UserAction = styled.button`
  background-color: rgba(0,0,0,0);
  border: 0px;
  text-align: left;
  justify-content: start;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px;
  border-radius: 2px;
	margin-top: 8px;
	text-decoration: none;
	color: black;

  &:nth-child(1) {
    margin-top: 0px;
  }

  &:hover {
		background-color: rgba(0,29,79,0.05);

		svg, path {
			fill: #4A90E2;
		}
	}
`;

const UserLink = styled(Link)`
  background-color: rgba(0,0,0,0);
  border: 0px;
  text-align: left;
  justify-content: start;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px;
  border-radius: 2px;
	margin-top: 8px;
	text-decoration: none;
	color: black;
	font-size: 11px;

  &:nth-child(1) {
    margin-top: 0px;
  }

  &:hover {
    background-color: rgba(0,29,79,0.05);
  }
`;

export {
	UserAction,
	UserLink,
}
